import { render, staticRenderFns } from "./TotalPendingOrdersCard.vue?vue&type=template&id=28682efa&lang=html&"
import script from "./TotalPendingOrdersCard.vue?vue&type=script&lang=js&"
export * from "./TotalPendingOrdersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports